export enum EOptimoProductType {
  Retail,
  HORECA,
}
